import React from 'react'
import classnames from 'classnames'

import {
  Panel,
  ComponentSize,
  ComponentColor,
  FlexBox,
  FlexDirection,
  InfluxColors,
  ButtonShape,
} from '@influxdata/clockface'

import LinkButton from 'js/components/LinkButton'
import PlanCardBanner from './PlanCardBanner'

export enum PlanType {
  Free = 'free',
  Annual = 'annual',
  UsageBased = 'usage-based',
}

interface Props {
  bannerDetails?: string
  bannerTitle?: string
  billingInfo: string
  buttonText: string
  buttonURL: string
  className?: string
  description: string
  icon: JSX.Element
  isHighlighted?: boolean
  limitations: string[][]
  openTab?: boolean
  planType: PlanType
  title: string
}

const PlanCard = ({
  bannerDetails,
  bannerTitle,
  billingInfo,
  buttonText,
  buttonURL,
  className,
  description,
  icon,
  isHighlighted,
  limitations,
  openTab,
  planType,
  title,
}: Props): JSX.Element => {
  const panelColor = isHighlighted ? InfluxColors.Pepper : InfluxColors.Castle
  const buttonColor = isHighlighted
    ? ComponentColor.Primary
    : ComponentColor.Default

  const panelClassName = classnames('plan-card', className)
  const hasBanner = !!(bannerTitle && bannerDetails)
  const buttonClass = classnames('plan-card--button', {
    ['highlighted']: isHighlighted,
  })

  const onClickButton = () => {
    window['dataLayer'] = window['dataLayer'] || []

    window['dataLayer'].push({
      event: 'cloudApp_plan_selected',
      plan_selected: planType,
    })
  }

  return (
    <Panel backgroundColor={panelColor} className={panelClassName}>
      <h2 className="plan-card--title">{title}</h2>
      <p>{description}</p>
      {icon}
      {hasBanner && <PlanCardBanner text={bannerDetails} title={bannerTitle} />}
      {limitations.map((limitationSection, i) => {
        return (
          <FlexBox
            className="plan-card--bordered-section"
            direction={FlexDirection.Column}
            key={i}
          >
            {limitationSection.map((limit) => {
              return (
                <strong className="plan-card--bolded" key={limit}>
                  {limit}
                </strong>
              )
            })}
          </FlexBox>
        )
      })}
      <div className="plan-card--bordered-section">
        <p className="plan-card--text">{billingInfo}</p>
      </div>
      <LinkButton
        className={buttonClass}
        color={buttonColor}
        onClick={onClickButton}
        openTab={openTab}
        shape={ButtonShape.StretchToFit}
        size={ComponentSize.Large}
        text={buttonText}
        url={buttonURL}
      />
    </Panel>
  )
}

export default PlanCard
